module.exports = __webpack_public_path__ + "img/4-yards.ca7eb900.svg";